import Joi from 'joi';
export var responseSchema = Joi.object({
    user: Joi.any(),
});
